import { Pagination, Tooltip, Avatar } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import { Table, Button } from "reactstrap";
import { formatNumberWithCommas } from "../../helpers/helpers";
import { FiEye, FiTrash2, FiClock, FiFileText } from "react-icons/fi";
import NotFoundDataUI from "../cards/NotFoundDataUI";
import DeleteModal from "../modals/DeleteModal";

const ReturnOrderTable = ({
  data,
  handleDelete,
  page,
  setPage,
  pageSize,
  setPageSize,
  totalPages,
  onClearSearch,
}) => {
  const history = useHistory();
  const [lastSeenOrder, setLastSeenOrder] = React.useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [itemToDelete, setItemToDelete] = React.useState(null);

  React.useEffect(() => {
    const lastSeen = localStorage.getItem('lastOpenedReturnOrder');
    setLastSeenOrder(lastSeen);
  }, []);

  return (
    <div>
      <Table
        responsive
        hover
        bordered
        className="mb-0"
        style={{
          fontSize: "14px",
          overflow: "hidden",
          border: "1px solid #e2e8f0"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#00509d", color: "white" }}>
            <th className="text-center" style={{ borderBottom: "none" }}>UID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>ID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Status</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Payment</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Customer / Vendor</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Source</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Total Amount</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data
              .sort((a, b) => parseInt(b.uid) - parseInt(a.uid))
              ?.map((order, index) => {
                const isSeen = lastSeenOrder === order.id;
                return (
                  <tr
                    key={index}
                    className="align-middle"
                    style={{
                      backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                      borderBottom: "1px solid #f1f5f9"
                    }}
                  >
                    <td className="text-center">
                      <span className="user-badge bg-secondary-soft text-dark fw-bold">
                        R-{order?.uid ?? order?.id}
                      </span>
                    </td>
                    <td className="text-center fw-600 text-primary small">
                      R{order?.id}
                    </td>
                    <td className="text-center">
                      <span className={`user-badge ${order?.return_status === 'completed' ? 'bg-success-soft text-success' : 'bg-primary-soft text-primary'}`}>
                        {order?.return_status || 'Pending'}
                      </span>
                    </td>
                    <td className="text-center text-capitalize">
                      <div className="d-flex align-items-center justify-content-center gap-1 small">
                        <FiClock className="text-muted" size={12} />
                        {order?.paymentStatus || 'Unpaid'}
                      </div>
                    </td>
                    <td className="text-center">
                      <div className="fw-bold text-dark text-truncate mx-auto" style={{ maxWidth: '200px' }}>
                        {order?.billing?.company || "Personal Customer"}
                      </div>
                      <div className="text-muted small italic">
                        {order?.billing?.email || 'No email provided'}
                      </div>
                    </td>
                    <td className="text-center">
                      <span className={`user-badge ${order?.websiteOrder ? "bg-info-soft text-info" : "bg-warning-soft text-warning"}`}>
                        {order?.websiteOrder ? "Website" : "Admin Portal"}
                      </span>
                    </td>
                    <td className="text-center fw-bold text-success">
                      $
                      {formatNumberWithCommas(
                        parseFloat(order?.total ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      )}
                    </td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center gap-2">
                        <Tooltip title="View Details">
                          <Button
                            color="link"
                            className="p-1 border-0"
                            onClick={() =>
                              history.push({
                                pathname: `/admin/return-order-details/${order?._id}`,
                                state: {
                                  order: order,
                                  isEdit: true,
                                },
                              })
                            }
                          >
                            <FiEye className="text-primary" size={18} />
                          </Button>
                        </Tooltip>

                        <Tooltip title="Delete Order">
                          <Button
                            color="link"
                            className="p-1 border-0"
                            onClick={() => {
                              setItemToDelete(order?._id);
                              setDeleteModalOpen(true);
                            }}
                          >
                            <FiTrash2 className="text-danger" size={16} />
                          </Button>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })
          ) : (
            <tr>
              <td colSpan="8" className="text-center py-4">
                <NotFoundDataUI 
                  message="No return orders found!" 
                  onClearSearch={onClearSearch}
                />
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {data && data.length > 0 && (
        <div className="d-flex justify-content-end mt-3 px-2">
          <Pagination
            size="small"
            current={page}
            total={totalPages}
            onChange={(value) => setPage(value)}
            pageSize={pageSize}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setPage(1);
            }}
            pageSizeOptions={['10', '25', '50', '100']}
          />
        </div>
      )}
      <DeleteModal 
        modal={deleteModalOpen} 
        toggle={() => setDeleteModalOpen(false)} 
        handleDelete={() => {
          handleDelete(itemToDelete);
          setDeleteModalOpen(false);
        }} 
      />
    </div>
  );
};

export default ReturnOrderTable;
